import { sortBy } from 'lodash';
import { AUDIENCE_TYPE } from '../../../../../app/engagement/constants';
import { AudienceOptions, DefaultSegments } from '../steps/campaign-configuration/audience/types';
import { useAudienceClients } from './use-audience-clients';
import { useAvailableAudiences } from './use-available-audiences';
import { useEditableField } from './use-editable-field';
export var useSelectedAudience = function () {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j;
    var customAudiencesField = useEditableField('usesCustomAudiences').field;
    var selectedAudiences = useAudienceClients().audiences;
    var _k = useAvailableAudiences({
        newCustomerWeeks: (_b = (_a = selectedAudiences === null || selectedAudiences === void 0 ? void 0 : selectedAudiences.value) === null || _a === void 0 ? void 0 : _a.newClients) === null || _b === void 0 ? void 0 : _b.weeks,
    }), availableAudiences = _k.availableAudiences, isLoading = _k.isLoading;
    var _l = (_c = selectedAudiences === null || selectedAudiences === void 0 ? void 0 : selectedAudiences.value) !== null && _c !== void 0 ? _c : {}, newClients = _l.newClients, regular = _l.regular, lapsing = _l.lapsing, prospective = _l.prospective, service = _l.service, barbers = _l.barbers, shops = _l.shops;
    var _m = (_d = availableAudiences === null || availableAudiences === void 0 ? void 0 : availableAudiences.segments) !== null && _d !== void 0 ? _d : {}, defaultClients = _m.default, audienceByService = _m.service, barber = _m.barber, shop = _m.shop;
    var selectedAudienceType = (customAudiencesField === null || customAudiencesField === void 0 ? void 0 : customAudiencesField.value) ? AudienceOptions.CUSTOM : AudienceOptions.ALL_CLIENTS;
    var isServiceEnabled = function (serviceId) {
        return service.serviceId === serviceId && service.enabled;
    };
    var audiences = [];
    if (customAudiencesField === null || customAudiencesField === void 0 ? void 0 : customAudiencesField.value) {
        var defaultSegments = [
            {
                title: DefaultSegments.NEW_CLIENTS,
                display: newClients.enabled,
                count: (_e = defaultClients === null || defaultClients === void 0 ? void 0 : defaultClients.find(function (_a) {
                    var name = _a.name;
                    return name === AUDIENCE_TYPE.new;
                })) === null || _e === void 0 ? void 0 : _e.customers,
                weeks: (_f = newClients.weeks) !== null && _f !== void 0 ? _f : 6,
            },
            {
                title: DefaultSegments.REGULAR_CLIENTS,
                display: regular.enabled,
                count: (_g = defaultClients === null || defaultClients === void 0 ? void 0 : defaultClients.find(function (_a) {
                    var name = _a.name;
                    return name === AUDIENCE_TYPE.regular;
                })) === null || _g === void 0 ? void 0 : _g.customers,
            },
            {
                title: DefaultSegments.LAPSED_CLIENTS,
                display: lapsing.enabled,
                count: (_h = defaultClients === null || defaultClients === void 0 ? void 0 : defaultClients.find(function (_a) {
                    var name = _a.name;
                    return name === AUDIENCE_TYPE.lapsing;
                })) === null || _h === void 0 ? void 0 : _h.customers,
            },
            {
                title: DefaultSegments.PROSPECTIVE,
                display: prospective.enabled,
                count: (_j = defaultClients === null || defaultClients === void 0 ? void 0 : defaultClients.find(function (_a) {
                    var name = _a.name;
                    return name === AUDIENCE_TYPE.prospective;
                })) === null || _j === void 0 ? void 0 : _j.customers,
            },
        ];
        var clientsByService = audienceByService
            ? sortBy(audienceByService === null || audienceByService === void 0 ? void 0 : audienceByService.map(function (_a) {
                var label = _a.label, id = _a.id, customers = _a.customers;
                return ({
                    title: label,
                    display: isServiceEnabled(id),
                    count: customers,
                });
            }), function (item) { return item.title.toLocaleUpperCase(); })
            : [];
        var clientsByBarber = barber
            ? sortBy(barber.map(function (_a) {
                var _b;
                var label = _a.label, id = _a.id, customers = _a.customers;
                return ({
                    title: label,
                    display: !!((_b = barbers[id]) === null || _b === void 0 ? void 0 : _b.enabled),
                    count: customers,
                });
            }), function (item) { return item.title.toUpperCase(); })
            : [];
        var clientsByShop = shop
            ? sortBy(shop.map(function (_a) {
                var _b;
                var label = _a.label, id = _a.id, customers = _a.customers;
                return ({
                    title: label,
                    display: !!((_b = shops[id]) === null || _b === void 0 ? void 0 : _b.enabled),
                    count: customers,
                });
            }), function (item) { return item.title.toUpperCase(); })
            : [];
        audiences.push.apply(audiences, defaultSegments);
        audiences.push.apply(audiences, clientsByService);
        audiences.push.apply(audiences, clientsByBarber);
        audiences.push.apply(audiences, clientsByShop);
    }
    else {
        var all = defaultClients === null || defaultClients === void 0 ? void 0 : defaultClients.find(function (_a) {
            var name = _a.name;
            return name === AUDIENCE_TYPE.all;
        });
        if (all) {
            audiences.push({
                title: all.label,
                display: true,
                count: all.customers,
            });
        }
    }
    return {
        isLoading: isLoading,
        selectedAudienceType: selectedAudienceType,
        audiences: audiences.filter(function (audience) { return audience.display; }),
    };
};
